import { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { analyticsSaveForLater } from "../../../state/modules/analytics/actions";
import {
  saveProduct as saveProductInState,
  removeSavedProduct,
  isProductSaved
} from "../../../state/modules/savedItems";
import { ERROR_ORIGIN } from "../../ErrorAlert/constants";
import { ADD_SAVED_PRODUCT } from "../../../state/modules/savedItems/constants";
import { saveProductForLater } from "../../../client/saveForLater";
import Icon from "../../Icon";
import { withTranslation } from "../../translation";
import styles from "./index.css";
import { getIconType } from "../../../state/modules/featureToggles/selectors";
import { getThreeLineLayout } from "../../../state/modules/layout/selectors";
import { setError } from "../../../state/modules/error";
import { getAriaLabelKey } from "./getAriaLabelKey";

const cx = classnames.bind(styles);

const VALENTINES = "valentines";
export class SaveForLater extends Component {
  flutter = [];
  state = {
    showFlutterAnimationIcons: false,
    animationFinishedCount: 0
  };

  handleSave = e => {
    e.preventDefault();

    const {
      productId,
      colourWayId,
      analyticsSaveForLater,
      saveProductInState,
      removeSavedProduct,
      setError
    } = this.props;

    saveProductForLater({
      productId,
      colourWayId
    }).catch(error => {
      removeSavedProduct(productId);

      const { isSaved } = this.props;

      if (!isSaved) {
        setError({
          message: error.message,
          actionType: ADD_SAVED_PRODUCT,
          errorOrigin: ERROR_ORIGIN.saveItem
        });
      }
    });

    saveProductInState(productId);
    analyticsSaveForLater({ productId });

    this.setState(
      { animationFinishedCount: 0, showFlutterAnimationIcons: true },
      () => this.move()
    );
  };

  handleAnimationEnd = () => {
    const { animationFinishedCount } = this.state;
    if (animationFinishedCount === this.flutter.length - 1) {
      this.setState({
        showFlutterAnimationIcons: false,
        animationFinishedCount: 0
      });
    } else {
      this.setState({ animationFinishedCount: animationFinishedCount + 1 });
    }
  };

  componentDidUpdate() {
    const { isSaved } = this.props;
    const { showFlutterAnimationIcons } = this.state;
    const showAnimation = this.showAnimation({
      isSaved,
      showFlutterAnimationIcons
    });

    if (showAnimation) {
      this.move();
    } else {
      this.flutter = [];
    }
  }

  move = /* istanbul ignore next */ () => {
    const { eventIconType } = this.props;

    if (eventIconType === VALENTINES) {
      return;
    }

    const directionX = Math.random() > 0.5 ? -1 : 1;
    const directionY = Math.random() > 0.5 ? -1 : 1;
    const distance = eventIconType ? 60 : 40;

    this.flutter.forEach(heart => {
      heart.style.setProperty(
        "--translateX",
        Math.random() * distance * directionX
      );
      heart.style.setProperty(
        "--translateY",
        Math.random() * distance * directionY
      );
    });
  };

  showAnimation = ({ isSaved, showFlutterAnimationIcons }) =>
    isSaved && showFlutterAnimationIcons;

  render() {
    const {
      props: {
        formatTranslation,
        isSaved,
        eventIconType,
        shouldUseThreeLineLayout
      },
      state: { showFlutterAnimationIcons }
    } = this;
    const celebrationStyle = cx(styles.flutter, {
      [styles[eventIconType]]: eventIconType
    });

    const flutterCount = eventIconType === VALENTINES ? 5 : 2;

    const showAnimation = this.showAnimation({
      isSaved,
      showFlutterAnimationIcons
    });

    return (
      <button
        type="button"
        data-auto-id="saveForLater"
        data-auto-state={isSaved ? "active" : "inactive"}
        disabled={isSaved}
        className={cx(styles.saveForLater, {
          [styles.saved]: isSaved,
          [styles.animated]: showAnimation,
          [styles.twoLineLayout]: !shouldUseThreeLineLayout,
          [styles.threeLineLayout]: shouldUseThreeLineLayout
        })}
        onClick={this.handleSave}
        aria-label={formatTranslation(getAriaLabelKey({ isSaved }))}
        aria-pressed={isSaved}
      >
        <Icon icon="heart" />
        {isSaved &&
          showFlutterAnimationIcons &&
          [...new Array(flutterCount)].map((_, flutterIndex) => (
            <span
              className={celebrationStyle}
              key={flutterIndex}
              onAnimationEnd={this.handleAnimationEnd}
              ref={node => (this.flutter[flutterIndex] = node)}
            />
          ))}
      </button>
    );
  }
}
SaveForLater.propTypes = {
  isSaved: PropTypes.bool.isRequired,
  productId: PropTypes.number.isRequired,
  colourWayId: PropTypes.number.isRequired,
  formatTranslation: PropTypes.func,
  saveProductInState: PropTypes.func.isRequired,
  removeSavedProduct: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  analyticsSaveForLater: PropTypes.func.isRequired,
  shouldUseThreeLineLayout: PropTypes.bool.isRequired,
  eventIconType: PropTypes.string
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { analyticsSaveForLater, saveProductInState, removeSavedProduct, setError },
    dispatch
  );

const mapStateToProps = (state, props) => ({
  isSaved: isProductSaved(state, props.productId),
  eventIconType: getIconType(state),
  shouldUseThreeLineLayout: getThreeLineLayout(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(SaveForLater));
